import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  computed,
  effect,
  inject,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import dayjs from 'dayjs';
import { retry } from 'rxjs';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { ModalService } from '../../../../services/modal.service';
import { ToastService } from '../../../../services/toast.service';
import { WeightService } from '../../../../services/weight.service';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { InputComponent } from '../../../atoms/input/input.component';
import { ModalHeaderComponent } from '../../../molecules/modal/modal-header/modal-header.component';
import { Weight } from '../../../pages/user/weight/weight.types';

@Component({
  selector: 'app-model-create-update-weigth',
  imports: [ButtonComponent, InputComponent, ModalHeaderComponent],
  templateUrl: './model-create-update-weigth.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModelCreateUpdateWeigthComponent {
  protected readonly RequestStateEnum = RequestStateEnum;
  static readonly overlayDataType: { id: string } | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: typeof ModelCreateUpdateWeigthComponent.overlayDataType
  ) {}

  private readonly weightService = inject(WeightService);
  private readonly modalService = inject(ModalService);
  private readonly toastService = inject(ToastService);

  readonly showDeleteButton = computed(() => !!this.data?.id);
  readonly requestState = this.weightService.getRequestState();
  readonly title = computed(() => (this.data?.id ? 'Messung bearbeiten' : 'Neue Messung'));

  private readonly init = effect(() =>
    this.data?.id ? this.getWeightById(this.data.id) : this.initForm()
  );

  readonly form = new FormGroup({
    date: new FormControl<string | null>(null, Validators.required),
    weight: new FormControl<number | null>(null, [
      Validators.required,
      Validators.min(0),
      Validators.max(300),
    ]),
  });

  private getWeightById(weightId: string): void {
    this.weightService
      .getWeightItemById(weightId)
      .pipe(retry(3))
      .subscribe({
        next: (response) => {
          this.initForm(response.payload);
        },
        error: (err) => {
          this.toastService.addToast('Ladefehler');
          this.modalService.close();
        },
      });
  }

  private initForm(initalState?: Weight): void {
    let weight = null;
    let date = dayjs();

    if (initalState) {
      weight = initalState.weight;
      date = dayjs(initalState.date);
    }

    this.form.controls.weight.setValue(weight);
    this.form.controls.date.setValue(date.format('YYYY-MM-DD'));
  }

  public deleteItem(): void {
    this.weightService.deleteWeightItem(this.data?.id!);
  }

  public onClick(): void {
    const fc = this.form.controls;
    const weight = fc.weight.value;
    const date = dayjs(fc.date.value, 'DD.MM.YYYY');

    if (this.data?.id) {
      this.weightService.updateWeightItem(this.data?.id!, weight!, date);
    } else {
      this.weightService.createWeightItem(weight!, date);
    }
  }
}
